import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.main`
  flex: 1;
  padding: 6rem 2rem 3rem;
  background: white;
`;

export const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  font-size: 3rem;
  font-weight: 800;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  font-family: var(--font-poppins), sans-serif;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const Section = styled.section`
  margin-bottom: 3rem;
`;

export const SectionTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1rem;
  font-family: var(--font-poppins), sans-serif;
`;

export const Paragraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 1rem;
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 1.5rem 0;
`;

export const ListItem = styled.li`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 0.75rem;
  padding-left: 1.5rem;
  position: relative;

  &:before {
    content: "•";
    color: #c8553d;
    font-weight: bold;
    position: absolute;
    left: 0;
  }
`;

export const Highlight = styled.span`
  color: #c8553d;
  font-weight: 600;
`;
